import angular from 'angular'
import uirouter from 'angular-ui-router'

import routing from './product.routes'
import ProductService from './product.service'
import ProductCard from './product-card.directive'
import ProductFormDirective from './product-form.directive'
import ProductStoreCard from './product-store-card.directive'
import ProductCategoriesSlideoutDirective from './categories-slideout.directive'
import StockLocationsSlideoutDirective from './stock-locations-slideout.directive'
import SuppliersSlideoutDirective from './suppliers-slideout.directive'
import ProductsController from './products.controller'
import ProductStoreController from './product-store.controller'
import ProductCategoryController from './product-category.controller'
import ProductController from './product.controller'
import NewProductController from './new-product.controller'
import './product.less'

export default angular.module('app.product', [uirouter, ProductCard, ProductStoreCard])
  .config(routing)
  .service('ProductService', ProductService)
  .directive('productForm', ProductFormDirective)
  .directive('productCategoriesSlideout', ProductCategoriesSlideoutDirective)
  .directive('stockLocationsSlideout', StockLocationsSlideoutDirective)
  .directive('suppliersSlideout', SuppliersSlideoutDirective)
  .controller('ProductsController', ProductsController)
  .controller('ProductCategoryController', ProductCategoryController)
  .controller('ProductStoreController', ProductStoreController)
  .controller('ProductController', ProductController)
  .controller('NewProductController', NewProductController)
  .name